import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        if (this.authService.isAuthenticated()) {
            const user = this.authService.getUser();
            const url = state.url;

            // Role 2 (Employees) restrictions
            if (user?.role === 2) {
                const allowedPaths = ['/registros', '/perfil', '/ajustes', '/login'];
                const isAllowed = allowedPaths.some(path => url.startsWith(path));

                if (!isAllowed) {
                    this.router.navigate(['/registros']);
                    return false;
                }
            }

            // Usuario autenticado, permitir acceso
            return true;
        }

        // Usuario no autenticado, redirigir a login
        console.log('Usuario no autenticado, redirigiendo a /login');
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
